"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import React, {
  forwardRef,
  Component,
  createRef
} from "react";
import classNames from "classnames";
import { observable, action } from "mobx";
import { observer } from "mobx-react";
import { Transition } from "react-transition-group";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import { Warning, IconSize } from "../../icons";
import { randomString } from "../../../utils";
import { formatTelephone } from "../../../utils/formatString";
import { Expandable } from "../../behaviors/Expandable";
import Tooltip from "../Tooltip/Tooltip";
import { TooltipSize } from "../Tooltip/Tooltip";
import { TooltipPosition } from "../Tooltip/Tooltip";
import { Label } from "../Label";
import * as styles from "./TextInput-css";
import { Text } from "../Text/Text";
import { darkTheme, lightTheme } from "../../../tokens/tokens-css";
export var TextInputType = /* @__PURE__ */ ((TextInputType2) => {
  TextInputType2["Text"] = "text";
  TextInputType2["Telephone"] = "tel";
  TextInputType2["Email"] = "email";
  TextInputType2["Password"] = "password";
  TextInputType2["Number"] = "number";
  TextInputType2["Search"] = "search";
  return TextInputType2;
})(TextInputType || {});
export var TextInputVariant = /* @__PURE__ */ ((TextInputVariant2) => {
  TextInputVariant2["Bordered"] = "bordered";
  TextInputVariant2["Underlined"] = "underlined";
  TextInputVariant2["Borderless"] = "borderless";
  return TextInputVariant2;
})(TextInputVariant || {});
export var TextInputSize = /* @__PURE__ */ ((TextInputSize2) => {
  TextInputSize2["XSmall"] = "x-small";
  TextInputSize2["Small"] = "small";
  TextInputSize2["Medium"] = "medium";
  TextInputSize2["Large"] = "large";
  return TextInputSize2;
})(TextInputSize || {});
const componentName = "text-input";
let TextInput = class extends Component {
  constructor() {
    super(...arguments);
    this.baseId = this.props.id || `${componentName}-${randomString()}`;
    this.endElementRef = createRef();
    this.startElementRef = createRef();
    this.isFocused = false;
    this.startElementSize = void 0;
    this.endElementSize = void 0;
    this.ErrorWrapper = ({ children }) => {
      const { error, errorVariant } = this.props;
      switch (errorVariant) {
        case "bottomTooltip": {
          return /* @__PURE__ */ React.createElement(
            Tooltip,
            {
              content: /* @__PURE__ */ React.createElement("div", { id: this.errorId }, error),
              size: TooltipSize.Large,
              show: !!error,
              position: TooltipPosition.Bottom,
              autoStack: true,
              isError: true
            },
            children
          );
        }
        default:
          return /* @__PURE__ */ React.createElement(React.Fragment, null, children, /* @__PURE__ */ React.createElement(Expandable, { expanded: !!error, timeout: AnimationDuration.Short }, ({ expandableElementRef }) => /* @__PURE__ */ React.createElement("div", { id: this.errorId, className: styles.error, ref: expandableElementRef, "aria-live": "polite" }, /* @__PURE__ */ React.createElement("div", { className: styles.errorIcon }, /* @__PURE__ */ React.createElement(Warning, { size: IconSize.Small, color: "critical" })), /* @__PURE__ */ React.createElement(Text, { lineHeight: "compact", size: "s" }, error))));
      }
    };
    this.onChange = (event) => {
      var _a, _b;
      if (this.props.type == "tel" /* Telephone */) {
        event.target.value = formatTelephone(event.target.value);
      }
      (_b = (_a = this.props).onChange) == null ? void 0 : _b.call(_a, event.target.value);
    };
    this.measureElements = () => {
      const { startElement, endElement } = this.props;
      const getWidth = (ref) => {
        var _a;
        return (_a = ref.current) == null ? void 0 : _a.getBoundingClientRect().width;
      };
      this.startElementSize = startElement ? getWidth(this.startElementRef) : void 0;
      this.endElementSize = endElement ? getWidth(this.endElementRef) : void 0;
    };
    this.handleBlur = (event) => {
      var _a, _b;
      this.isFocused = false;
      (_b = (_a = this.props).onBlur) == null ? void 0 : _b.call(_a, event);
    };
    this.handleFocus = (event) => {
      var _a, _b;
      this.isFocused = true;
      (_b = (_a = this.props).onFocus) == null ? void 0 : _b.call(_a, event);
    };
  }
  componentDidMount() {
    this.measureElements();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.startElement && !this.props.startElement || prevProps.endElement && !this.props.endElement) {
      this.measureElements();
    }
  }
  render() {
    const _a = this.props, {
      type,
      multiline,
      label,
      placeholder,
      value,
      variant,
      className,
      labelHidden,
      size,
      theme,
      innerRef,
      error,
      errorVariant,
      disabled,
      onMouseEnter,
      onMouseLeave,
      onKeyDown,
      onClick,
      maxLength,
      startElement,
      endElement,
      readOnly,
      role,
      onChange,
      id,
      elementSize,
      onFocus,
      onBlur
    } = _a, rest = __objRest(_a, [
      "type",
      "multiline",
      "label",
      "placeholder",
      "value",
      "variant",
      "className",
      "labelHidden",
      "size",
      "theme",
      "innerRef",
      "error",
      "errorVariant",
      "disabled",
      "onMouseEnter",
      "onMouseLeave",
      "onKeyDown",
      "onClick",
      "maxLength",
      "startElement",
      "endElement",
      "readOnly",
      "role",
      "onChange",
      "id",
      "elementSize",
      "onFocus",
      "onBlur"
    ]);
    const inputId = `${this.baseId}-input`;
    const labelId = `${this.baseId}-label`;
    const elementType = multiline ? "textarea" : "input";
    const InputElement = elementType;
    const isUnderlined = variant === "underlined" /* Underlined */;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(componentName, styles.container, className, {
          [lightTheme]: theme === "light",
          [darkTheme]: theme === "dark"
        })
      },
      /* @__PURE__ */ React.createElement(
        Label,
        {
          long: true,
          hidden: labelHidden || isUnderlined,
          disabled,
          size: size === "x-small" /* XSmall */ ? "s" : "m",
          className: classNames(styles.label, `${componentName}__label`),
          id: labelId,
          htmlFor: inputId
        },
        label
      ),
      /* @__PURE__ */ React.createElement(this.ErrorWrapper, null, /* @__PURE__ */ React.createElement("div", { className: classNames(styles.inputWrapper({ size }), `${componentName}__input-container`) }, /* @__PURE__ */ React.createElement(
        InputElement,
        __spreadValues({
          className: classNames(styles.input({ size, variant }), `${componentName}__${elementType}`),
          type: multiline ? void 0 : type,
          ref: innerRef,
          id: inputId,
          "aria-labelledby": labelId,
          "aria-describedby": error ? this.errorId : void 0,
          "aria-multiline": multiline,
          "aria-invalid": !!error,
          placeholder,
          onChange: this.onChange,
          value,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          disabled,
          onMouseEnter,
          onMouseLeave,
          onKeyDown,
          onClick,
          maxLength,
          readOnly,
          style: { paddingInlineStart: this.startElementSize, paddingInlineEnd: this.endElementSize },
          role,
          size: elementSize
        }, rest)
      ), isUnderlined && /* @__PURE__ */ React.createElement(Transition, { onEnter: forceReflow, in: this.isFocused, timeout: AnimationDuration.Medium }, (status) => /* @__PURE__ */ React.createElement("div", { className: styles.underline({ focused: ["entering", "entered"].includes(status) }) })), !!startElement && /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.measureElements }, /* @__PURE__ */ React.createElement("div", { ref: this.startElementRef, className: classNames(styles.element({ position: "start" })) }, startElement)), !!endElement && /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.measureElements }, /* @__PURE__ */ React.createElement("div", { ref: this.endElementRef, className: classNames(styles.element({ position: "end" })) }, endElement))))
    );
  }
  get errorId() {
    return `${this.baseId}-error`;
  }
};
TextInput.defaultProps = {
  type: "text" /* Text */,
  placeholder: "",
  variant: "bordered" /* Bordered */,
  size: "medium" /* Medium */,
  errorVariant: "default"
};
__decorateClass([
  observable.ref
], TextInput.prototype, "isFocused", 2);
__decorateClass([
  observable.ref
], TextInput.prototype, "startElementSize", 2);
__decorateClass([
  observable.ref
], TextInput.prototype, "endElementSize", 2);
__decorateClass([
  action
], TextInput.prototype, "componentDidUpdate", 1);
__decorateClass([
  action
], TextInput.prototype, "measureElements", 2);
__decorateClass([
  action
], TextInput.prototype, "handleBlur", 2);
__decorateClass([
  action
], TextInput.prototype, "handleFocus", 2);
TextInput = __decorateClass([
  observer
], TextInput);
export default forwardRef(function textInput(props, ref) {
  return /* @__PURE__ */ React.createElement(TextInput, __spreadValues({ innerRef: ref }, props));
});
